import axios from "axios";

export const getBookingAcrissList =  async (req: { tenants: string[], dealers: string[] }): Promise<string[]> => {

    const response = await axios.get('/booking/search/acrisses', { params:{
        tenants: req.tenants.join(","),
        dealers: req.dealers.join(",")
    } });
    return response.data;
};
